// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"877e256f","175":"a468d2be","270":"a24c46fc","320":"b54a9d5d","347":"b219f246","437":"1a802b2d","638":"1989a083","711":"64ea2c2a","790":"556b1464","818":"c25fa3f9","871":"3e5fcc91"}[chunkId] + ".chunk.js";
};